
import user from "../assets/png/potrait.jfif"

export const headerData = {
    name: 'Haron Njuguna',
    title: "Hello! I am",
    desciption: "Hello! I'm Haron Njuguna, a skilled and dynamic programmer with a passion for innovation and a knack for problem-solving. With expertise in automating daily operations, I can streamline processes and boost efficiency to take your business to the next level. Let's work together to achieve your goals!",
    image: user,
    imagebw: user,
    resumePdf: 'https://drive.google.com/file/d/1YQq0NHouPF3VA7mWu6u9SU7g-3wmau3k/view?usp=sharing'
}
